import logo from './logo.svg';
import './App.css';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import {BrowserRouter as Router, Routes, Route} from "react-router-dom"
import Skills from './pages/Skills';
import Portfolio from './pages/Portfolio';
import Contact from './pages/Contact';

function App() {
  return (
    <div className="App">
        <Router>
            <Navbar/>
            <Routes>
              <Route path='/' element={<Home/>} />
              <Route path='/skills' element={<Skills/>} />
              <Route path='/portfolio' element={<Portfolio/>} />
              <Route path='/contact' element={<Contact/>} />
            </Routes>
        </Router>
    </div>
  );
}

export default App;
